import React from "react";
import { Button } from "@/components/ui/button";
import { Phone, Mail, MessageCircle, ArrowRight, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const TocTocCTA = () => {
  const whatsappLink =
    "https://wa.me/554797367396?text=Ol%C3%A1!%20Gostaria%20de%20solicitar%20um%20or%C3%A7amento.";

  return (
    <section className="py-16 md:py-24 bg-gradient-to-r from-[#261E13] to-[#323031] text-white relative overflow-hidden">
        {/* Background decoration */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 border border-[#FF5605] rounded-full"></div>
          <div className="absolute bottom-10 right-10 w-48 h-48 border border-[#FF5605] rounded-full"></div>
          <div className="absolute top-1/2 left-1/4 w-24 h-24 border border-[#FF5605] rounded-full"></div>
        </div>
        
        <div className="container max-w-7xl mx-auto px-4 relative z-10">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-slate-50">
              Pronto para <span className="text-[#FF5605]">valorizar</span> seu imóvel?
            </h2>
            <p className="text-xl text-white/90 max-w-3xl mx-auto">
              Entre em contato conosco e descubra como nossa fotografia profissional 
              pode transformar seu imóvel em uma apresentação irresistível.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            {/* Phone contact */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center group hover:bg-white/20 transition-all duration-300">
              <div className="w-16 h-16 bg-[#FF5605]/20 rounded-xl flex items-center justify-center mx-auto mb-6 group-hover:bg-[#FF5605]/30 transition-colors">
                <Phone className="h-8 w-8 text-[#FF5605]" />
              </div>
              <h3 className="text-lg font-bold mb-3 text-slate-50">Telefone</h3>
              <p className="text-white/80 mb-4">Fale direto com nossa equipe</p>
              <a href="tel:+5547997367396" className="text-[#FF5605] font-medium hover:text-[#E14D04] transition-colors">
                (47) 99736-7396
              </a>
            </div>
            
            {/* Email contact */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center group hover:bg-white/20 transition-all duration-300">
              <div className="w-16 h-16 bg-[#FF5605]/20 rounded-xl flex items-center justify-center mx-auto mb-6 group-hover:bg-[#FF5605]/30 transition-colors">
                <Mail className="h-8 w-8 text-[#FF5605]" />
              </div>
              <h3 className="text-lg font-bold mb-3 text-slate-50">E-mail</h3>
              <p className="text-white/80 mb-4">Envie sua mensagem</p>
              <a href="mailto:contato@toctocbr.com" className="text-[#FF5605] font-medium hover:text-[#E14D04] transition-colors">
                contato@toctocbr.com
              </a>
            </div>
            
            {/* WhatsApp contact */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center group hover:bg-white/20 transition-all duration-300">
              <div className="w-16 h-16 bg-[#FF5605]/20 rounded-xl flex items-center justify-center mx-auto mb-6 group-hover:bg-[#FF5605]/30 transition-colors">
                <MessageCircle className="h-8 w-8 text-[#FF5605]" />
              </div>
              <h3 className="text-lg font-bold mb-3 text-slate-50">WhatsApp</h3>
              <p className="text-white/80 mb-4">Atendimento rápido e prático</p>
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#FF5605] font-medium hover:text-[#E14D04] transition-colors"
              >
                Conversar agora
              </a>
            </div>
          </div>

          <div className="text-center">
            <Button
              asChild
              size="lg"
              className="bg-[#FF5605] hover:bg-[#E14D04] text-white rounded-full px-8 py-4 text-lg font-medium group mr-4"
            >
              <Link to="/contato">
                Solicitar Orçamento
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Link>
            </Button>

            <Button
              asChild
              variant="outline"
              size="lg"
              className="border-white hover:bg-white rounded-full px-8 py-4 text-lg font-medium text-orange-600"
            >
              <Link to="/portfolio">Ver Portfólio</Link>
            </Button>
          </div>
          
          <div className="text-center mt-8 text-white/70 flex items-center justify-center">
            <MapPin className="h-4 w-4 mr-2" />
            <p>Atendemos Balneário Camboriú e região.</p>
          </div>
        </div>
      </section>
  );
};

export default TocTocCTA;
